// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3PL0t","consentsList":"PatientConsents_consentsList__33wHM","consentsListEmpty":"PatientConsents_consentsListEmpty__1kxN9"};